__turbopack_context__.v({
  "container": "YFvMnq_container",
  "placeholderWrapper": "YFvMnq_placeholderWrapper",
  "wrapper": "YFvMnq_wrapper",
});
